import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import '../PageCss/HansaFlexIndiaPages/Journey.css';
import JourneyCard from '../../Components/JourneyCard/JourneyCard';
import JourneyCardR from '../../Components/JourneyCard/JourneyCardR';
import CenterStage from '../../Components/CenterStage/CenterStage';
import imgHANSAFLEX_Ireland_Cover_Journey from '../../assets/History/imgHistory.jpg'
import imgHANSAFLEX_Ireland_PlantHoses from '../../assets/Journey/HANSAFLEX_Ireland_PlantHoses.webp'
import imgHANSAFLEX_Ireland_Zero_PhotoGrid from '../../assets/Journey/HANSAFLEX_Ireland_Zero_PhotoGrid.webp'
import imgHANSAFLEX_Ireland_New_branch_2900 from '../../assets/Journey/HANSAFLEX_Ireland_New_branch_2900.jpg'


import AOS from 'aos';
import 'aos/dist/aos.css';

function Journey() {

    const isMobile = window.innerWidth <= 789;

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
        AOS.init({
            // Global settings:
            disable: false,
            startEvent: 'DOMContentLoaded',
            initClassName: 'aos-init',
            animatedClassName: 'aos-animate',
            useClassNames: false,

            // Settings that can be overridden on per-element basis:
            offset: 300,
            delay: 0,
            duration: 500,
            easing: 'ease',
            once: false,
            mirror: false,
            anchorPlacement: 'top-bottom',
        });
    }, []);



    return (
        <div className='journey-content'>
            <CenterStage imageSrc={imgHANSAFLEX_Ireland_Cover_Journey} title="Come with us on our Journey !" paragraph="HANSA-FLEX Ireland boasts a storied history defined by strategic evolution and adaptability. Over time, it has showcased resilience and innovation, adeptly surmounting obstacles while steadily broadening its impact within the industry." />

            <div className='div-timeline-wrapper'>
                <br /><br /><br /><br />
                {isMobile ? <></> : <><div className='vertical-line'></div></>}

                {/* <div>
                    <JourneyCard
                        title="April 2018"
                        description=""
                        imageUrl={imgPhotoneeded}
                        additionalDescription="HANSA‑FLEX Ireland Ltd. established in Dublin"
                    />
                </div> */}

                <div >
                    <JourneyCardR
                        title="May 2018"
                        description=""
                        imageUrl={imgHANSAFLEX_Ireland_PlantHoses}
                        additionalDescription="HANSA-FLEX NI acquires Plant Hoses Ltd."
                    />
                </div>

                <div >
                    <JourneyCard
                        title="May 2021"
                        description=""
                        imageUrl={imgHANSAFLEX_Ireland_Zero_PhotoGrid}
                        additionalDescription="HANSA-FLEX NI acquires Zero Hydraulics Ltd."
                    />
                </div>

                <div>
                    <JourneyCardR
                        title="November 2025"
                        description=""
                        imageUrl={imgHANSAFLEX_Ireland_New_branch_2900}
                        additionalDescription="HANSA-FLEX NI: New branch 2900 opened in Newtownabbey"
                    />
                </div>

                {/* <div>
                    <JourneyCard
                        title="2019"
                        description="National Heavy Equipment Show"
                        imageUrl={img2019}
                        additionalDescription="Equipment Show"
                    />
                </div> */}

                {/* <div>
                    <JourneyCardR
                        title="2023"
                        description="Always assisting with hydraulic solutions, resilience, and innovation!"
                        imageUrl={img2023}
                        additionalDescription="Future of reliable hydraulics"
                    />
                </div> */}
            </div>
        </div>
    );
}

export default Journey;
